import { nothing } from 'lit-html';
import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';

/**
 * @component {kat-selection-list-item} KatalSelectionListItem Child component of selection-list-item
 * @slot default Default slot for list items - must use kat-selection-list-item to work properly
 */
@register('kat-selection-list-item')
export class KatSelectionListItem extends KatLitElement {
  /** Whether the list item is selected */
  @property()
  selected?: boolean;

  /** Associated value. Used by parent selection list when selected */
  @property()
  value?: string;

  /**
   * Text to appear within the default slot. Is overridden if slot content exists.
   *
   */
  @property()
  name?: string;

  firstUpdated() {
    this.tabIndex = 0;
  }

  render() {
    return html`<slot>${this.name || nothing}</slot>`;
  }
}
